import { render, staticRenderFns } from "./quantity-unit-select.vue?vue&type=template&id=52335ec0&"
import script from "./quantity-unit-select.vue?vue&type=script&lang=js&"
export * from "./quantity-unit-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports